import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';

export function SectionLinks({ links, noFollow = false, isMobile = false }) {
  return links.map(({ link, title, text, compare }) => (
    <div
      key={`${link}-${title}`}
      className={classnames('pe-1 d-inline-block mb-0_5 align-top', { 'w-50': !isMobile })}
      style={{ width: isMobile ? '100%' : '50%' }}
    >
      {compare && (
        <div className="fw-bold text-primary-darker">
          {title}
          <span className="ms-0_25 size-10 text-primary-darker icon-arrow-right4" aria-hidden />
        </div>
      )}
      {(!compare || text) && (
        <a
          href={link}
          className="text-primary-darker d-inline-block"
          data-tracking-id="compare_suggested_set"
          rel={noFollow ? 'nofollow' : undefined}
        >
          {!compare && (
            <div className="fw-bold">
              {title}
              <span className="size-10 text-primary-darker icon-arrow-right4" aria-hidden />
            </div>
          )}
          {text && <p className="size-16 text-gray-darker m-0">{text}</p>}
        </a>
      )}
    </div>
  ));
}

SectionLinks.propTypes = {
  links: PropTypes.arrayOf(
    PropTypes.shape({
      link: PropTypes.string,
      text: PropTypes.string,
      title: PropTypes.string,
      compare: PropTypes.number,
    })
  ).isRequired,
  noFollow: PropTypes.bool,
  isMobile: PropTypes.bool,
};
